/**
 * 設定ファイル（開発環境用）
 */

/**
 * Repository 設定
 */
export const repository = {
    // isMock: false,
    baseURL: 'https://csite.desknets.com/api',
    timeout: 30000,
    // cacheKey: '_c'
}
export const endpoints = {
    lbcApiUrl: 'https://csite.desknets.com/tools/lbc_api_proxy.php',
}
